import { connect } from 'react-redux';
import {
  getIsLoggedIn,
  getClientData,
  getClientUnconfirmedPhone,
  getConfirmedAt,
  getClientAuthToken,
} from '../../../store/client/selectors';
import {
  logInAction,
  confirmClientAction,
  signUpAction,
  logOutAction,
  setClientConfirmPhone,
  setClientInfo,
} from '../../../store/client/actions';
import ClientForm from '../components/Client';

const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  unconfirmedPhone: getClientUnconfirmedPhone(state),
  isConfirmedClientEmail: getConfirmedAt(state),
  clientData: getClientData(state),
  clientAuthToken: getClientAuthToken(state),
});

const mapDispatchToProps = (dispatch) => ({
  setClientInfo: (data) => dispatch(setClientInfo(data)),
  confirmClient: (data) => dispatch(confirmClientAction(data)),
  logIn: (data) => dispatch(logInAction(data)),
  signUp: (data) => dispatch(signUpAction(data)),
  logOut: () => dispatch(logOutAction()),
  setConfirmedPhone: (data) => dispatch(setClientConfirmPhone(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientForm);
